import { CheckCircle } from 'lucide-react';
import { useEffect } from 'react';

export default function Success() {
	useEffect(() => {
		const timer = setTimeout(() => {
			window.close();
		}, 2000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div className='min-h-screen grid place-items-center bg-green-50'>
			<div className='text-center animate-fade-in'>
				<div className='flex justify-center mb-4'>
					<CheckCircle className='w-12 h-12 text-green-600 animate-bounce' />
				</div>
				<h1
					className='text-2xl font-bold text-green-600 mb-2'
					role='status'
				>
					Authentication Successful!
				</h1>
				<p className='text-gray-600'>
					You can now close this window...
					<span className='inline-block ml-1 animate-pulse'>⌛</span>
				</p>
			</div>
		</div>
	);
}
